'use client';

import moment from 'moment-timezone';
import type React from 'react';
import type { TenantContactMessage } from 'src/types';

interface ScheduledMessageProps {
	message: TenantContactMessage;
	jobTimezone: string;
}

const formatScheduledAt = (scheduledAt: string, timezone: string): string => {
	if (!scheduledAt || !timezone) return '';
	return moment
		.utc(scheduledAt, 'YYYY-MM-DD HH:mm:ss')
		.tz(timezone)
		.format('MMM D, YYYY - hh:mm A z');
};

const ScheduledMessage: React.FC<ScheduledMessageProps> = ({
	message,
	jobTimezone,
}) => {
	const isCancelled = !!message.cancelled_at;
	const dir = message.direction;

	return (
		<div
			className={`tenant-texts__row tenant-texts__row--${dir} tenant-texts__row--scheduled`}
		>
			<div
				className={`tenant-texts__scheduled ${
					isCancelled ? 'tenant-texts__scheduled--cancelled' : ''
				}`}
			>
				<div className="tenant-texts__scheduled-user">
					{message.sender}
					{message.designation ? <span> ({message.designation})</span> : null}
				</div>
				<div className="tenant-texts__scheduled-head">
					{message.scheduled_at ? (
						<span
							className={isCancelled ? 'tenant-texts__scheduled-strike' : ''}
						>
							Scheduled for{' '}
							{formatScheduledAt(message.scheduled_at, jobTimezone)}
						</span>
					) : null}
					{isCancelled ? (
						<span className="tenant-texts__scheduled-cancel-text">
							{message.cancelled_by
								? `Cancelled by ${message.cancelled_by}`
								: 'Cancelled'}
						</span>
					) : null}
				</div>
				<div className="tenant-texts__scheduled-body">
					<p>{message.text || ''}</p>
				</div>
			</div>
		</div>
	);
};

export default ScheduledMessage;
